import { createContext } from 'react';

const CompareContext = createContext(void 0);

CompareContext.displayName = 'context(compare)';

export default CompareContext;